<template>
  <v-menu bottom left offset-y>
    <v-btn slot="activator" icon small>
      <v-icon>fas fa-exclamation</v-icon>
    </v-btn>
    <v-list>
      <v-list-tile @click="displayContentsReportDialog = true">
        <v-list-tile-title>
          {{ lang.contents_report_title }}
        </v-list-tile-title>
      </v-list-tile>
    </v-list>

    <v-dialog v-model="displayContentsReportDialog" max-width="600">
      <v-card v-if="clipIsLoggedIn">
        <v-card-title>
          <span class="headline">{{ lang.contents_report_title }}</span>
        </v-card-title>
        <v-card-text v-if="!displayReportSentDialog">
          <span>{{ lang.contents_report_description }}</span>
          <v-flex class="pt-3">
            <v-select
              single-line
              outline
              :label="lang.select_contents_report_category"
              :items="[
                lang.contents_report_category_in_appropriate,
                lang.contents_report_category_uncomfortable,
                lang.contents_report_category_copyright,
                lang.contents_report_category_illegal,
                lang.contents_report_category_etc
              ]"
              v-model="contentsReportCategory"
              v-validate="'required'"
              data-vv-name="contentsReportCategory"
              :error-messages="errors.collect('contentsReportCategory')"
              required
            >
            </v-select>
          </v-flex>
          <v-flex>
            <v-textarea
              single-line
              v-model="contentsReportBody"
              outline
              no-resize
              v-validate="'required|max:3000'"
              data-vv-name="contentsReportText"
              :error-messages="errors.collect('contentsReportText')"
              required
            ></v-textarea>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn
              :class="[$style.btnTextStyle, 'd-inline-block']"
              color="info"
              @click="submitContentsReport"
              :loading="isLoading"
              :disabled="
                errors.has('contentsReportCategory') ||
                  errors.has('contentsReportText')
              "
            >
              {{ lang.submit }}
            </v-btn>
          </v-flex>
        </v-card-text>

        <template v-else>
          <v-card-text>
            <span>{{ lang.sent }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              :class="$style.btnTextStyle"
              flat="flat"
              @click="displayContentsReportDialog = false"
            >
              {{ lang.close }}
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>

      <v-card v-else>
        <v-card-text class="text-xs-left">
          <span class="headline text-xs-left">
            {{ lang.contents_report_title }}
          </span>
        </v-card-text>
        <v-card-text class="text-xs-center">
          <div class="text-xs-left">{{ lang.login_necessary }}</div>
          <v-btn
            color="primary"
            :class="[$style.btnTextStyle, 'd-inline-block', 'headline']"
            :large="$vuetify.breakpoint.smAndUp"
            @click="moveSpecifiedPage(clipLoginUrl)"
          >
            {{ lang.login_here }}
          </v-btn>
        </v-card-text>
        <v-card-text class="text-xs-left">
          <span class="headline text-xs-left">
            {{ lang.problem_report_no_login }}
          </span>
        </v-card-text>
        <v-card-text class="text-xs-left">
          <div class="text-xs-left">
            {{ lang.problem_report_no_login_description_1 }}
          </div>
          <div class="text-xs-left">
            <vc-share-text-contains-link
              :replace="{
                ':mail': {
                  text: lang.problem_report_no_login_description_mail_url,
                  href: mailLink,
                  target: '_blank'
                }
              }"
            >
              {{ lang.problem_report_no_login_description_2 }}
            </vc-share-text-contains-link>
          </div>
          <ul>
            <li>{{ lang.problem_report_no_login_mail_must_list_1 }}</li>
            <li>{{ lang.problem_report_no_login_mail_must_list_2 }}</li>
          </ul>
          <div class="text-xs-left">
            {{ lang.problem_report_no_login_description_3 }}
          </div>
          <div class="text-xs-left">
            {{ lang.problem_report_no_login_description_4 }}
          </div>
          <div class="text-xs-left">
            {{ lang.problem_report_no_login_description_5 }}
          </div>

          <vc-share-a :href="privacyUrl" target="_blank">
            {{ lang.problem_report_no_login_about_personal_info_link }}
          </vc-share-a>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-menu>
</template>

<script>
export default {
  name: "vc-share-menu-button",
  data: () => ({
    displayContentsReportDialog: false,
    displayReportSentDialog: false,
    contentsReportCategory: "",
    contentsReportBody: "",
    dictionary: {
      custom: {
        contentsReportCategory: {},
        contentsReportText: {}
      }
    },
    isLoading: false
  }),
  props: {
    contentsId: {
      type: Number,
      default: 0
    },
    lang: {
      type: Object,
      default: () => {
        return {
          contents_report_title: "問題のあるコンテンツです",
          contents_report_description:
            "コンテンツに問題がある場合はこちらからご報告ください（3000文字以内）。",
          select_contents_report_category: "問題点を選択",
          contents_report_category_in_appropriate: "掲載に不適切である",
          contents_report_category_uncomfortable:
            "不快に感じる、モラルに反している",
          contents_report_category_copyright: "著作権などの権利を侵害している",
          contents_report_category_illegal: "法律や規約に違反している",
          contents_report_category_etc: "その他",
          submit: "送信",
          sent: "送信しました。",
          report_contents: "内容",
          problem: "問題点",
          close: "閉じる",
          login_necessary: "CLIPアカウントでログインしてください",
          login_here: "ログインはこちら"
        };
      }
    },
    clipIsLoggedIn: {
      type: Boolean,
      default: false
    },
    clipLoginUrl: {
      type: String,
      default: ""
    },
    localeCode: {
      type: String,
      default: ""
    },
    validationLang: {
      type: Object,
      default: () => {
        return {
          required: "",
          max: {
            string: ""
          }
        };
      }
    },
    reportContents: {
      type: Function,
      default: () => {}
    },
    mailLink: {
      type: String,
      default: ""
    },
    privacyUrl: {
      type: String,
      default: "#"
    }
  },
  mounted: function() {
    this.dictionary.custom.contentsReportText.max = this.validationLang.max.string
      .replace(":attribute", this.lang.report_contents)
      .replace(":max", "3000");
    this.dictionary.custom.contentsReportText.required = this.validationLang.required.replace(
      ":attribute",
      this.lang.report_contents
    );
    this.dictionary.custom.contentsReportCategory.required = this.validationLang.required.replace(
      ":attribute",
      this.lang.problem
    );
    this.$validator.localize(this.localeCode, this.dictionary);
  },
  watch: {
    displayContentsReportDialog: function(newVal) {
      if (newVal == false) {
        setTimeout(() => {
          this.displayReportSentDialog = false;
        }, 500);
      }
    }
  },
  methods: {
    closeReportDialog: function() {
      this.displayContentsReportDialog = false;
    },
    submitContentsReport: function() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this.isLoading = true;

        let requestData = {
          id: this.contentsId,
          problem: this.contentsReportCategory,
          comment: this.contentsReportBody
        };

        this.reportContents(requestData).then(value => {
          if (value === 0) {
            this.isLoading = false;
            this.contentsReportCategory = "";
            this.contentsReportBody = "";
            this.displayReportSentDialog = true;
          } else {
            this.displayContentsReportDialog = false;
            this.isLoading = false;
          }
        });
      });
    },
    moveSpecifiedPage: function(url) {
      location.href = url;
    }
  }
};
</script>

<style module>
.btnTextStyle {
  text-transform: none !important;
}
</style>
